export const MAX_UPLOAD_FILE_SIZE_BYTES = 5368709120 as const // 5 GB
